import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { BrowserGlobalsService } from '@core/services/browser-globals.service';

@Injectable()
export class ApplicationHeaderInterceptor implements HttpInterceptor {
    windowRef: Window;

    constructor(private browserGlobals: BrowserGlobalsService) {
        this.windowRef = this.browserGlobals.windowRef();
    }
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (request.url.indexOf('assets') === -1) {
            return next.handle(
                request.clone({
                    setHeaders: {
                        application_id: environment.application_id,
                        application_key: environment.application_key,
                        // 'Content-Type': 'application/json',
                        ...{ domain: this.windowRef.location.hostname },
                    },
                })
            );
        } else {
            return next.handle(request);
        }
    }
}
